export default __webpack_public_path__ + "static/media/discovery-01.7cc758cb.png";